<template>
  <v-card>
    <v-card-title class="text-h5 font-weight-bold justify-center">
      Signee
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="d-flex justify-center">
      <div class="px-4 my-auto">
        <user-avatar
          :size="60"
          :user="user"
          borderColor="performance"
          color="performance"
          cssClass="halo text-h3"
          textColor="white"
        ></user-avatar>
      </div>
      <div class="px-4">
        <div class="subtitle-1 font-weight-medium pb-4">
          {{ user.firstName }}'s Signature
        </div>
        <v-btn v-if="isComplete" outlined color="lighttext" readonly>
          <v-icon color="success" class="mr-2">check_circle</v-icon>Signed Off
        </v-btn>
        <v-btn v-else-if="profile.id == user.id" @click="showDialog">
          Sign & Approve
        </v-btn>
        <v-btn v-else outlined disabled>
          <v-icon class="mr-2">cancel</v-icon>
          Waiting for Response
        </v-btn>
      </div>
    </v-card-text>
    <annual-review-signoff-dialog
      ref="signoffDialog"
    ></annual-review-signoff-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import AnnualReviewSignoffDialog from "@/components/annualreviews/AnnualReviewSignoffDialog";
export default {
  components: { AnnualReviewSignoffDialog },
  name: "AnnualReviewSigneeCard",
  props: { isManager: { type: Boolean, default: false } },
  computed: {
    user() {
      return this.isManager
        ? this.annualreview.manager
        : this.annualreview.user;
    },
    isComplete() {
      return (
        (this.isManager
          ? this.annualreview.managerSignoffDate
          : this.annualreview.userSignoffDate) != null
      );
    },
    ...mapGetters({
      annualreview: "annualreview/annualreview",
      profile: "profile/profile"
    })
  },
  methods: {
    showDialog() {
      this.$refs.signoffDialog.showDialog(this.user);
    }
  }
};
</script>
